import { render, staticRenderFns } from "./CreateCustomfieldModal.vue?vue&type=template&id=f4874c9c&scoped=true&"
import script from "./CreateCustomfieldModal.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomfieldModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCustomfieldModal.vue?vue&type=style&index=0&id=f4874c9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4874c9c",
  null
  
)

export default component.exports